import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';

import fallbackImage from '../../public/assets/images/myPath/productThumnail.svg';

dayjs.locale('th');
dayjs.extend(buddhistEra);

export const PRODUCT_TYPE = {
  CLASSIC_COURSE: 'CLASSIC_COURSE',
  COMPETITION_COURSE: 'COMPETITION_COURSE',
  UPSKILL_COURSE: 'UPSKILL_COURSE',
  EXAM_HUB: 'EXAM_HUB',
  MOCK_EXAM: 'MOCK_EXAM',
  SHORT_COURSE: 'SHORT_COURSE',
};

export const PRODUCT_TYPE_TO_LABEL = {
  CLASSIC_COURSE: 'เนื้อหา',
  COMPETITION_COURSE: 'เรียน (ติวเข้ม)',
  UPSKILL_COURSE: 'ฝึกฝน (UpSkill)',
  EXAM_HUB: 'Exam hub',
  MOCK_EXAM: 'Mock Exam',
  SHORT_COURSE: 'Short Course',
};

export const SUBJECT_NAME = {
  MATH1: 'คณิต 1',
  MATH: 'คณิต',
  ENGLISH: 'ภาษาอังกฤษ',
  PHYSICS: 'ฟิสิกส์',
  CHEMISTRY: 'เคมี',
  BIOLOGY: 'ชีววิทยา',
  TPAT1: 'ความถนัดแพทย์',
  TGAT: 'TGAT',
  THAI: 'ภาษาไทย',
  SOCIAL: 'สังคม',
  TPAT3: 'TPAT3',
};

export const SUBJECT_CODE = {
  TPAT1: '10',
  GPAX: '100',
  GPA_PE: '101',
  GPA_ART: '102',
  GPA_MATH: '161',
  GPA_SCIENCE: '162',
  GPA_CHEMISTRY: '165',
  GPA_BIOLOGY: '166',
  GPA_SOCIAL: '170',
  GPA_THAI: '181',
  GPA_ENGLISH: '182',
  TPAT2: '20',
  TPAT21: '21',
  TPAT22: '22',
  TPAT23: '23',
  TPAT3: '30',
  TPAT4: '40',
  TPAT5: '50',
  MATH1: '61',
  MATH2: '62',
  APPLIED_SCIENCE: '63',
  PHYSICS: '64',
  CHEMISTRY: '65',
  BIOLOGY: '66',
  SOCIAL: '70',
  THAI: '81',
  ENGLISH: '82',
  FRENCH: '83',
  GERMAN: '84',
  JAPANESE: '85',
  KOREAN: '86',
  CHINESE: '87',
  BALI: '88',
  SPANISH: '89',
  TGAT: '90',
  TGAT1: '91',
  TGAT2: '92',
  TGAT3: '93',
};

export const getBorderColorBySubjectName = (theme, subjectName) => {
  switch (subjectName) {
    case SUBJECT_NAME.MATH:
    case SUBJECT_NAME.MATH1:
      return theme.colors.myPath.subjects.math1[700];
    case SUBJECT_NAME.PHYSICS:
      return theme.colors.myPath.subjects.physics[700];
    case SUBJECT_NAME.CHEMISTRY:
      return theme.colors.myPath.subjects.chemistry[700];
    case SUBJECT_NAME.BIOLOGY:
      return theme.colors.myPath.subjects.biology[700];
    case SUBJECT_NAME.THAI:
      return theme.colors.myPath.subjects.thai[700];
    case SUBJECT_NAME.ENGLISH:
      return theme.colors.myPath.subjects.english[700];
    case SUBJECT_NAME.SOCIAL:
      return theme.colors.myPath.subjects.social[700];
    case SUBJECT_NAME.TGAT:
      return theme.colors.myPath.subjects.tgat[700];
    case SUBJECT_NAME.TPAT1:
      return theme.colors.myPath.subjects.tpat1[700];
    case SUBJECT_NAME.TPAT3:
      return theme.colors.myPath.subjects.tpat3[700];
    default:
      return theme.colors.myPath.gray[300];
  }
};

export const getColorBySubjectName = (theme, subjectName) => {
  switch (subjectName) {
    case SUBJECT_NAME.MATH:
    case SUBJECT_NAME.MATH1:
      return theme.colors.myPath.subjects.math1[500];
    case SUBJECT_NAME.PHYSICS:
      return theme.colors.myPath.subjects.physics[500];
    case SUBJECT_NAME.CHEMISTRY:
      return theme.colors.myPath.subjects.chemistry[500];
    case SUBJECT_NAME.BIOLOGY:
      return theme.colors.myPath.subjects.biology[500];
    case SUBJECT_NAME.THAI:
      return theme.colors.myPath.subjects.thai[500];
    case SUBJECT_NAME.ENGLISH:
      return theme.colors.myPath.subjects.english[500];
    case SUBJECT_NAME.SOCIAL:
      return theme.colors.myPath.subjects.social[500];
    case SUBJECT_NAME.TGAT:
      return theme.colors.myPath.subjects.tgat[500];
    case SUBJECT_NAME.TPAT1:
      return theme.colors.myPath.subjects.tpat1[500];
    case SUBJECT_NAME.TPAT3:
      return theme.colors.myPath.subjects.tpat3[500];
    default:
      return theme.colors.myPath.gray[500];
  }
};

export const getLightColorBySubjectName = (theme, subjectName) => {
  switch (subjectName) {
    case SUBJECT_NAME.MATH:
    case SUBJECT_NAME.MATH1:
      return theme.colors.myPath.subjects.math1[100];
    case SUBJECT_NAME.PHYSICS:
      return theme.colors.myPath.subjects.physics[100];
    case SUBJECT_NAME.CHEMISTRY:
      return theme.colors.myPath.subjects.chemistry[100];
    case SUBJECT_NAME.BIOLOGY:
      return theme.colors.myPath.subjects.biology[100];
    case SUBJECT_NAME.THAI:
      return theme.colors.myPath.subjects.thai[100];
    case SUBJECT_NAME.ENGLISH:
      return theme.colors.myPath.subjects.english[100];
    case SUBJECT_NAME.SOCIAL:
      return theme.colors.myPath.subjects.social[100];
    case SUBJECT_NAME.TGAT:
      return theme.colors.myPath.subjects.tgat[100];
    case SUBJECT_NAME.TPAT1:
      return theme.colors.myPath.subjects.tpat1[100];
    case SUBJECT_NAME.TPAT3:
      return theme.colors.myPath.subjects.tpat3[100];
    default:
      return theme.colors.bsGrays.gray100;
  }
};

/**
 * Returns a theme color mapped to a given product type.
 *
 * This helper ensures that each product type consistently uses
 * a specific color from the design system (`theme.color.myPath`).
 *
 * Product type → color mapping:
 * - CLASSIC_COURSE      → gray
 * - COMPETITION_COURSE  → primary
 * - UPSKILL_COURSE      → success
 * - SHORT_COURSE        → info
 * - MOCK_EXAM           → error
 * - EXAM_HUB            → secondary
 * - default / fallback  → gray
 *
 * @param {object} theme - The theme object containing color definitions.
 * @param {PRODUCT_TYPE} productType - The product type enum.
 * @returns {string} The corresponding color value from the theme.
 */
export const getColorByProductType = (theme, productType) => {
  switch (productType) {
    case PRODUCT_TYPE.CLASSIC_COURSE:
      return theme.colors.myPath.gray;
    case PRODUCT_TYPE.COMPETITION_COURSE:
      return theme.colors.myPath.primary;
    case PRODUCT_TYPE.UPSKILL_COURSE:
      return theme.colors.myPath.success;
    case PRODUCT_TYPE.SHORT_COURSE:
      return theme.colors.myPath.info;
    case PRODUCT_TYPE.MOCK_EXAM:
      return theme.colors.myPath.error;
    case PRODUCT_TYPE.EXAM_HUB:
      return theme.colors.myPath.secondary;
    default:
      return theme.colors.myPath.gray;
  }
};

/**
 * Formats a duration in seconds to a human-readable string format.
 *
 * @param {number} seconds - The duration in seconds.
 * @return {string} The formatted duration string.
 */
export const formatDuration = (seconds) => {
  const totalMinutes = Math.floor((Number.isFinite(seconds) ? seconds : 0) / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours > 0) return `${hours}:${minutes.toString().padStart(2, '0')} ชม.`;
  return `${minutes} นาที`;
};

/**
 * Formats the total hours for a student semester.
 *
 * @param {number} weekdayCapWorkload - The workload for weekdays.
 * @param {number} weekendCapWorkload - The workload for weekends.
 * @return {string} The formatted total hours in the format "HH:00".
 */
export const formatTargetHours = (weekdayCapWorkload, weekendCapWorkload) => {
  let totalHours = 0;

  totalHours += weekdayCapWorkload * 5;
  totalHours += weekendCapWorkload * 2;
  return `${totalHours}:00`;
};

/**
 * Formats the current hours from a duration in seconds.
 *
 * @param {number} seconds - The duration in seconds.
 * @return {string} The formatted current hours in the format "HH:MM".
 */
export const formatCurrentHours = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  return `${hours}:${minutes.toString().padStart(2, '0')}`;
};

/**
 * Clamps a value within a specified range.
 *
 * @param {number} v - The value to clamp.
 * @param {number} [min=0] - The minimum value (default: 0).
 * @param {number} [max=100] - The maximum value (default: 100).
 * @return {number} The clamped value.
 */
export const clamp = (v, min = 0, max = 100) =>
  Math.min(Math.max(Number.isFinite(v) ? v : 0, min), max);

/**
 * Formats a date range for a semester.
 *
 * @param {string} startDate - The start date of the semester.
 * @param {string} endDate - The end date of the semester.
 * @return {string} The formatted date range in the format "DD MMMM YYYY - DD MMMM YYYY (X.0 เดือน)".
 */
export const formatSemesterDateRanges = (startDate, endDate) => {
  if (!startDate || !endDate) {
    throw new Error('startDate or endDate is not defined');
  }

  const start = dayjs(startDate).locale('th');
  const end = dayjs(endDate).locale('th');

  if (!start.isValid() || !end.isValid()) {
    throw new Error('startDate or endDate is invalid');
  }
  if (start.isAfter(end)) {
    throw new Error('startDate is greater than endDate');
  }

  const startDay = start.date();
  const startMonth = start.format('MMMM');
  const startYear = start.format('BBBB');

  const endDay = end.date();
  const endMonth = end.format('MMMM');
  const endYear = end.format('BBBB');

  const monthsFloat = end.diff(start, 'month', true);
  const roundedOneDecimal = Math.round(monthsFloat * 10) / 10;

  const safeValue = Object.is(roundedOneDecimal, -0) ? 0 : roundedOneDecimal;
  return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear} (${safeValue.toFixed(
    1
  )} เดือน)`;
};

export const getFallbackImage = () => {
  return fallbackImage;
};
